import { FileText, Phone, User } from 'lucide-react'

import { Link } from '@/components/ui/Link'
import { Demo, DsSection } from '../primitives'

export function LinksSection() {
  return (
    <DsSection
      id="links"
      title="Links"
      marketing
      intro="Link labels are sentence case — e.g. “Learn more”, not “Learn More”."
    >
      <Demo label="Light" className="flex flex-wrap items-center gap-7">
        <Link kind="nav" href="#links">
          About
        </Link>
        <Link kind="footer" href="#links">
          Privacy Policy
        </Link>
        <Link kind="util" icon={<User />} href="#links">
          Login
        </Link>
        <Link kind="util" icon={<Phone />} href="#links">
          (770) 765-0331
        </Link>
      </Demo>
      <Demo label="On dark" dark className="flex flex-wrap items-center gap-7">
        <Link kind="nav" onDark href="#links">
          About
        </Link>
        <Link kind="footer" onDark href="#links">
          Privacy Policy
        </Link>
        <Link kind="util" onDark icon={<User />} href="#links">
          Login
        </Link>
      </Demo>
      <Demo label="Small (size=sm)" className="flex flex-wrap items-center gap-7">
        <Link kind="util" size="sm" icon={<FileText />} href="#links">
          View quote documents
        </Link>
        <Link kind="nav" size="sm" href="#links">
          About
        </Link>
      </Demo>
      <Demo
        label="Util emphasis (brand green — content only, not nav)"
        className="flex flex-wrap items-center gap-7"
      >
        <Link kind="util" size="sm" icon={<FileText />} href="#links">
          Default
        </Link>
        <Link kind="util" size="sm" emphasis icon={<FileText />} href="#links">
          Emphasis
        </Link>
      </Demo>
    </DsSection>
  )
}
